import React from 'react';
import { useTranslation } from 'react-i18next';

import { formatNumber } from 'helpers/helpers';
import useTableStyles from 'apps/Pdf/styles/tables';
import useGeneralStyles from 'apps/Pdf/styles/general';
//import { AssetCategory } from 'apps/Pdf/templates/Interfaces';

import { AmountValue, AssetCategory } from 'common/interfaces';
import { Currency } from 'enums';

import H2 from 'apps/Pdf/components/common/H2';

interface Props {
  data: AssetCategory[];
  currency: Currency;
  total?: AmountValue | null;
  savingIsins: string[];
}

const CurrentPortfolioTable = (props: Props) => {
  const styles = useGeneralStyles();
  const tables = useTableStyles();
  const { t } = useTranslation();
  const { data, total, currency } = props;

  return total !== undefined && total !== null ? (
    <>
      <H2>Držené ETF, FONDY A HOTOVOST podle investičních kategorií</H2>

      <table className={`${tables.root} ${tables.portfolio} ${tables.currentPortfolio}`}>
        <thead>
          <tr>
            <th>&nbsp;</th>
            <th className={styles.left}>ISIN</th>
            <th className={styles.left}>Investiční kategorie / vybraný fond</th>
            <th>Počet kusů</th>
            <th>Cena</th>
            <th>Hodnota</th>
            <th>Kurz měny</th>
            <th>Hodnota {t(`currency_${currency}`)}</th>
          </tr>
        </thead>

        <tbody>
          {data.map((assetCategory) => {
            const categorySize = assetCategory.assetClasses.length;

            return assetCategory.assetClasses.map((assetClass, i) => {
              const classSize = assetClass.assets?.length || 0;

              return assetClass.assets?.map((asset, x) => {
                return (
                  <tr
                    className={categorySize === i + 1 && classSize === x + 1 ? 'divider' : undefined}
                    key={`asset_${asset.isin}`}
                  >
                    <td className={`${assetCategory.code}`}>&nbsp;</td>
                    <td className={`${styles.supplement} ${styles.left} ${styles.smallText}`}>{props.savingIsins.includes(asset.isin) ? '' : asset.isin}</td>
                    <td className={styles.left}>
                      {t(assetClass.title)}
                      <br />
                      <span className={`${styles.supplement} ${styles.smallText}`}>{asset.title}</span>
                    </td>
                    <td>
                      {asset.statement?.pieces &&
                        asset.statement.pieces.value !== null &&
                        asset.statement.pieces.value !== undefined &&
                        formatNumber(asset.statement.pieces.value, 4)}
                    </td>
                    <td>
                      {asset.statement?.price &&
                        asset.statement.price.value !== null &&
                        asset.statement.price.value !== undefined && (
                          <>
                            {formatNumber(asset.statement.price.value, 4)}&nbsp;
                            {asset.statement.price.currency}
                          </>
                        )}
                    </td>
                    <td>
                      {asset.statement?.originalValue && asset.statement.originalValue.value !== null && (
                        <>
                          {formatNumber(asset.statement.originalValue.value, 2)}&nbsp;
                          {asset.statement.originalValue.currency}
                        </>
                      )}
                    </td>
                    <td>
                      {asset.statement?.exchangeRate &&
                        asset.statement.exchangeRate.value !== null &&
                        formatNumber(asset.statement.exchangeRate.value, 3)}
                    </td>
                    <td className={styles.bold}>
                      {asset.statement?.convertedValue &&
                        asset.statement.convertedValue.value !== null &&
                        formatNumber(asset.statement.convertedValue.value, 2)}
                    </td>
                  </tr>
                );
              });
            });
          })}
          <tr className="sum">
            <td>&nbsp;</td>
            <td colSpan={6} className={`${styles.left} ${styles.bold}`}>
              Celkem
            </td>
            <td className={styles.bold}>{formatNumber(total.value, 2)}</td>
          </tr>
        </tbody>
      </table>
    </>
  ) : null;
};

export default CurrentPortfolioTable;
